import { useEffect, useState } from "react";
import { axiosInstance } from "../axios-instance";
import { attachAuthInterceptors } from "./auth-interceptors";
import { useTokenBroker } from "./session";

type MsalRequestInterceptorProps = {
  children: React.ReactNode;
};

const MsalRequestInterceptor: React.FC<MsalRequestInterceptorProps> = ({
  children,
}) => {
  const [interceptorLoaded, setInterceptorLoaded] = useState(false);
  const broker = useTokenBroker();

  useEffect(() => {
    const detach = attachAuthInterceptors(axiosInstance, broker);
    setInterceptorLoaded(true);
    return detach;
  }, [broker]);

  if (!interceptorLoaded) {
    return <></>;
  }

  return <>{children}</>;
};

export default MsalRequestInterceptor;
